<template>
  <v-card flat>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-toolbar dense flat dark color="primary">
              <v-toolbar-title>
                <span class>{{ titleDesc }}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="value.name"
                v-validate="'required'"
                data-vv-name="name"
                :error-messages="errors.collect('name')"
                label="Name"
                required
                class="mt-6"
              />

              <v-textarea v-model="value.notes" label="Notes" ref="notes"/>

              <datasource-select
                v-model="value.datasource_id"
                :dealer_id="value.dealer_id"
                :datasource_id="value.datasource_id"
                v-on:selected-datasource="onDatasourceChange"
                :error-messages="errors.collect('datasource_id')"
                datasourceType="DmsDatasource"
              />

              <dynamic-combobox
                v-model="value.recipients"
                :initial-items="userEmails"
                :persistent-hint="true"
                label="Recipients"
                :small-chips="false"
                :solo="false"
                hint="Add receipients for this email report"
                class="mt-3"
              />
              <ampm-time-picker
                v-model="value.execution_time"
                v-validate="'required'"
                data-vv-name="execution_time"
                :error-messages="errors.collect('execution_time')"
                label="Execute At"
                :allowed-interval-minutes="ui.timePickerInterval"
                @change="onDatasourceMailerChange('execution_time', $event)"
              />

              <ymd-datepicker
                v-model="value.schedule_start_on"
                :initialDate="value.schedule_start_on || defaultScheduleStartOn()"
                v-validate="{ required: true }"
                data-vv-name="schedule_start_on"
                :error-messages="errors.collect('schedule_start_on')"
                label="Start On"
                required
                :date.sync="value.schedule_start_on"
              />

              <v-row align="center" justify="center">
                <v-col cols="9" class="ma-0 mp-0">
                  <v-text-field
                    v-model="value.schedule"
                    v-validate="{ required: true}"
                    data-vv-name="schedule"
                    :error-messages="errors.collect('schedule')"
                    label="Schedule"
                    prepend-icon="mdi-calendar"
                    :hint="scheduleDescription"
                    :persistent-hint="true"
                    class="pr-6"
                  />
                </v-col>
                <v-col cols="3" class="ma-0 mp-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        href="https://rrule.dealerapps.io/"
                        target="_blank"
                      >Create a Rule</v-btn>
                    </template>
                    <span>
                      Once you create the schedule on the resulting link,
                      <br />Copy and Paste the RRULE schedule in the schedule field
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-col class="text-center">
                <v-btn class="ml-2" color="primary" type="submit" @click.prevent="saveScheduled">Save and Schedule</v-btn>
                <v-btn class="ml-2" color="secondary" type="submit" @click.prevent="saveUnscheduled">Save Unscheduled</v-btn>
                <v-btn class="ml-2" :to="{ name: 'datasource_mailers_path' }">Cancel</v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import {
  DatasourceSelect,
  YMDDatePicker,
  AmPmTimePicker,
  DynamicComboBox
} from '@/components/inputs'
import validationMixin from '@/validators/validations_mixin'

const rrulestr = require('rrule').rrulestr

export default {
  name: 'datasource-mailer',
  mixins: [validationMixin],
  components: {
    [DatasourceSelect.name]: DatasourceSelect,
    [YMDDatePicker.name]: YMDDatePicker,
    [AmPmTimePicker.name]: AmPmTimePicker,
    [DynamicComboBox.name]: DynamicComboBox
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ui: {
        timePickerInterval: 15
      }
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    ...mapState('UserStore', ['users']),
    userEmails () {
      return this.users.map(u => u.email)
    },
    titleDesc () {
      if (this.value.id) {
        return `Editing [${this.value.name}]`
      } else {
        return 'New Scheduled Report'
      }
    },
    scheduleDescription: function () {
      if (this.value.schedule) {
        try {
          return rrulestr(this.value.schedule).toText()
        } catch (error) {
          return 'Invalid Rule Expression'
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    onDatasourceChange (datasource) {
      this.onDatasourceMailerChange('datasource_id', datasource.id)
    },
    setDealer (dealerId) {
      this.onDatasourceMailerChange('dealer_id', dealerId)
    },
    async loadUsers () {
      await this.$store.dispatch('UserStore/fetchUsers')
      await this.$store.dispatch('getUserAttributes')
    },
    onDatasourceMailerChange (prop, val) {
      this.$emit('input', { ...this.value, [prop]: val })
    },
    defaultScheduleStartOn () {
      return new Date().toISOString().slice(0, 10)
    },
    saveScheduled () {
      this.onDatasourceMailerChange('status', 'scheduled')
      this.$nextTick(() => {
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            this.$emit('on-save', this.value)
          }
        })
      })
    },
    saveUnscheduled () {
      this.onDatasourceMailerChange('status', 'unscheduled')
      this.$nextTick(() => {
        this.$emit('on-save', this.value)
      })
    }

  },
  mounted () {
    this.setDealer(this.dealer.id)
    this.loadUsers()
      .then(() => this.$logger.trace('success loaded users'))
      .catch(error => {
        this.$logger.error('error loading users', error.message)
        this.$flash({
          showClose: true,
          message: `Error loading users. ${error.message}`,
          type: 'error',
          duration: 0
        })
      })
  }
}
</script>
